<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Crear Solicitud
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos Solicitud
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Activo:</label>
            <v-select v-model="form.machinery_id" :options="machineryss" value="id" label="name"></v-select>
            </div>
            <div class="container pb-8 pr-6 w-full lg:w-1/6">
            <label class="form-label" >Proveedor:</label>
            <v-select v-model="form.contact_id" :options="contacts" value="id" label="nid"></v-select>
            </div>   
              <text-input v-model="form.number" :error="form.errors.number" :req="form.number" class="pb-8 pr-6 w-full lg:w-1/6" label="Nº Factura" required/>   
              <text-input v-model="form.total" :error="form.errors.total" :req="form.total" class="pb-8 pr-6 w-full lg:w-1/6" label="V. Total" required/>         
              <div class="container pb-8 pr-6 w-full lg:w-1/6">
            <label class="form-label" >Fecha </label>
          <date-picker v-model="form.fecha" lang="es" ></date-picker>
          </div>

         <file-input v-model="form.foto_url" :error="form.errors.foto_url" :req="form.foto_url" class="pb-8 pr-6 w-full lg:w-2/6" type="file" label="Respaldos" required/>
        <!--  <img v-bind:src="photo" width="90" height="90" alt="">-->
        <textarea-input v-model="form.detalle" :error="form.errors.detalle" :req="form.detalle" class="pb-8 pr-6 w-full lg:w-4/6" label="Detalle" required />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Solicitud</loading-button>
        </div>
      </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: { title: 'Crear Solicitud' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    DatePicker,
    TextareaInput,
  },
  layout: Layout,
  props: {
    contacts: Array,
    machinerys: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      loading: true,
      machineryss: this.machinerys,
      form: this.$inertia.form({
        foto_url: null,
        total: null,
        number:null,
        fecha: null,
        detalle: null,
        machinery_id: null,
        contact_id: null,
       
      }),
    }
  },
  async mounted(){
    await this.users
    this.loading=false
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    store() {
      
      this.form.post('/applicationbuy')
    },
   
  },
}
</script>